import React from 'react'
import { useDealList } from '../hooks/useDealList'
import DealsTable from './DealsTable'

const DealListTab: React.FC = () => {
  const { data, loading, error, refresh } = useDealList()

  const handleRefresh = async () => {
    await refresh()
  }

  if (loading) {
    return (
      <div 
        className="d-flex flex-column align-items-center justify-content-center text-center"
        style={{ 
          minHeight: '60vh',
          padding: '2rem'
        }}
      >
        <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="text-muted mb-0" style={{ fontSize: '1.1rem' }}>Loading your deals...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        <div className="d-flex align-items-center">
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          <div className="flex-grow-1">
            <strong>Error loading deals:</strong> {error}
          </div>
          <button 
            className="btn btn-outline-danger btn-sm"
            onClick={handleRefresh}
          >
            <i className="bi bi-arrow-clockwise me-1"></i>
            Retry
          </button>
        </div>
      </div>
    )
  }

  const opportunities = data?.opportunities || []
  const totalCount = data?.totalCount || 0
  const fieldMappings = data?.fieldMappings || []

  return (
    <div className="deal-list-tab">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <p className="text-muted mb-0">
            Track your opportunities and lender submissions
          </p>
        </div>
        <button 
          className="btn btn-outline-primary"
          onClick={handleRefresh}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Refreshing...
            </>
          ) : (
            <>
              <i className="bi bi-arrow-clockwise me-2"></i>
              Refresh
            </>
          )}
        </button>
      </div>

      {/* Stats Summary */}
      <div className="row mb-4">
        <div className="col-md-3 col-lg-2">
          <div className="card border-0 bg-primary text-white">
            <div className="card-body text-center py-2">
              <div className="fs-3 fw-normal">{totalCount}</div>
              <div className="small">Total Deals</div>
            </div>
          </div>
        </div>
      </div>

      {/* Opportunities List */}
      {opportunities.length === 0 ? (
        <div className="text-center py-5">
          <div className="mb-4">
            <i className="bi bi-inbox display-1 text-muted"></i>
          </div>
          <h4 className="text-muted mb-3">No Opportunities Found</h4>
          <p className="text-muted mb-4">
            You don't have any opportunities yet. Start by submitting a new deal to see it appear here.
          </p>
          <button 
            className="btn btn-primary"
            onClick={() => window.location.href = '/submit-deal'}
          >
            <i className="bi bi-plus-circle me-2"></i>
            Submit Your First Deal
          </button>
        </div>
      ) : (
        <DealsTable 
          opportunities={opportunities}
          fieldMappings={fieldMappings}
        />
      )}
    </div>
  )
}

export default DealListTab
